import { render, staticRenderFns } from "./batchAllocationView.vue?vue&type=template&id=d966f556&scoped=true&"
import script from "./batchAllocationView.vue?vue&type=script&lang=js&"
export * from "./batchAllocationView.vue?vue&type=script&lang=js&"
import style0 from "./batchAllocationView.vue?vue&type=style&index=0&id=d966f556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d966f556",
  null
  
)

component.options.__file = "batchAllocationView.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VContainer,
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
})
